import { render, staticRenderFns } from "./ForumChatEditorDetailsContent.vue?vue&type=template&id=b14dfe6a&scoped=true"
import script from "./ForumChatEditorDetailsContent.vue?vue&type=script&lang=js"
export * from "./ForumChatEditorDetailsContent.vue?vue&type=script&lang=js"
import style0 from "./ForumChatEditorDetailsContent.vue?vue&type=style&index=0&id=b14dfe6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14dfe6a",
  null
  
)

export default component.exports